"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customPropTypes = require("@paprika/helpers/lib/customPropTypes");

var _button = _interopRequireDefault(require("@paprika/button"));

var _heading = _interopRequireDefault(require("@paprika/heading"));

var sc = _interopRequireWildcard(require("./Header.styles"));

var propTypes = {
  children: _propTypes["default"].node.isRequired,
  hasCloseButton: _propTypes["default"].bool,
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),
  onClose: _propTypes["default"].func,
  refHeading: (0, _customPropTypes.RefOf)()
};
var defaultProps = {
  hasCloseButton: true,
  level: 3,
  onClose: function onClose() {},
  refHeading: null
};

var Header = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      level = props.level,
      hasCloseButton = props.hasCloseButton,
      onClose = props.onClose,
      refHeading = props.refHeading,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "level", "hasCloseButton", "onClose", "refHeading"]);
  return /*#__PURE__*/_react["default"].createElement(sc.Header, (0, _extends2["default"])({
    ref: ref
  }, moreProps), /*#__PURE__*/_react["default"].createElement(_heading["default"], {
    level: level,
    displayLevel: 3,
    isLight: true,
    ref: refHeading
  }, children), hasCloseButton && /*#__PURE__*/_react["default"].createElement(_button["default"].Close, {
    "data-pka-anchor": "modal.header.close-button",
    isSemantic: false,
    onClick: onClose,
    size: "medium"
  }));
});

Header.displayName = "Modal.Header";
Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
var _default = Header;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map